import { SupplierDto } from '@/api/generated';
import {
  customerStatusOptionsTranslation,
  SupplierStatusOptionsTranslation,
} from '@/assets/locales/utils/dictionaries/dictionaries.translation.pl.ts';
import { SupplierDetailsTab } from '@/views/suppliers/details/model/SupplierDetailsTab.model.ts';

export type SuppliersDetailsTranslation = {
  contacts: {
    title: string;
  };
  header: {
    button: {
      edit: string;
    };
  };
  main: {
    fields: Record<
      keyof Omit<SupplierDto, 'address' | 'createdAt' | 'name' | 'supplierId'>,
      string
    > & {
      nipNotAvailable: string;
      statusOptions: SupplierStatusOptionsTranslation;
    };
  };
  tabs: Record<SupplierDetailsTab, string>;
};

export const suppliersDetailsTranslation: SuppliersDetailsTranslation = {
  contacts: {
    title: 'Kontakty',
  },
  header: {
    button: {
      edit: 'Edytuj',
    },
  },
  main: {
    fields: {
      nip: 'NIP',
      nipNotAvailable: 'Brak numeru NIP',
      note: 'Notatka',
      regon: 'REGON',
      status: 'Status',
      statusOptions: customerStatusOptionsTranslation,
      type: 'Typ',
    },
  },
  tabs: {
    [SupplierDetailsTab.CONTACTS]: 'Kontakty',
    [SupplierDetailsTab.FILES]: 'Pliki',
    [SupplierDetailsTab.MAIN]: 'Szczegóły dostawcy',
    [SupplierDetailsTab.TASKS]: 'Zadania',
  },
};
